import axios from 'axios';

import { apiRequest } from './client';
import {
  GetUploadUrlRequest,
  PresignedUrlResponse,
  CreateReceiptRequest,
  UploadedReceipt,
} from './types';

// Get presigned URL for file upload
export const getUploadUrl = async (
  data: GetUploadUrlRequest,
  token: string
): Promise<PresignedUrlResponse> => {
  return apiRequest<PresignedUrlResponse>({
    endpoint: '/files/upload-url',
    method: 'POST',
    body: data,
    token,
  });
};

// Upload file to S3 using presigned URL
export const uploadFileToS3 = async (
  presignedUrl: string,
  file: File,
  onProgress?: (progress: number) => void
): Promise<void> => {
  const formData = new FormData();
  formData.append('file', file);

  await axios.put(presignedUrl, file, {
    headers: {
      'Content-Type': file.type,
    },
    onUploadProgress: progressEvent => {
      if (onProgress && progressEvent.total) {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(progress);
      }
    },
  });
};

// Create uploaded receipt for uploaded file
export const createUploadedReceipt = async (
  data: CreateReceiptRequest,
  token: string
): Promise<UploadedReceipt> => {
  return apiRequest<UploadedReceipt>({
    endpoint: '/uploaded-receipts',
    method: 'POST',
    body: data,
    token,
  });
};

// Get download URL for a file
export const getDownloadUrl = async (
  fileKey: string,
  token: string
): Promise<PresignedUrlResponse> => {
  return apiRequest<PresignedUrlResponse>({
    endpoint: `/files/download-url?fileKey=${encodeURIComponent(fileKey)}`,
    method: 'GET',
    token,
  });
};

// Delete a file
export const deleteFile = async (
  fileKey: string,
  token: string
): Promise<{ message: string }> => {
  return apiRequest<{ message: string }>({
    endpoint: `/files/${encodeURIComponent(fileKey)}`,
    method: 'DELETE',
    token,
  });
};
